<template>
  <v-app-bar
    app
    flat
    height="fit-content"
    color="#ffffff"
    class="nav-bar"
    id="navbar"
    absolute
  >
    <v-container fluid class="nav-bar">
      <v-row align="center" justify="space-between">
        <!-- Logo Section -->
        <v-col cols="4" class="d-flex align-center">
          <img
            src="@/assets/logo.png"
            alt="Logo"
            class="logo"
            @click="$router.push('/')"
            @contextmenu.prevent
          />
        </v-col>

        <!-- Title Section -->
        <v-col cols="4" class="d-flex justify-center align-center">
          <h1 class="title">Club Mizabook_FSBM</h1>
        </v-col>

        <!-- Contact Section -->
        <v-col cols="4" class="d-flex justify-end align-center">
          <v-btn text class="action-link" @click="$router.push('/Contactus')">
            Contacter Nous
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
export default {
  name: "AppNavBar",
};
</script>

<style scoped>
/* Navbar Styles */
.nav-bar {
  color: black;
  background-color: #fdf1dd;
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  transition: top 0.3s ease-in-out;
}

.logo {
  height: 100px;
  max-width: 100%;
  margin-left: 35%;
  cursor: pointer;
}

.title {
  font-size: 24px;
  color: #ad7e3f;
  font-family: "Noto Kufi Arabic", sans-serif;
  font-weight: bold;
  text-align: center;
  margin: 0;
  position: relative;
  transition: color 0.3s ease-in-out;
}
.title::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  width: 0;
  height: 2px;
  background-color: #97682b;
  transition: width 0.3s ease, left 0.3s ease;
}

.title:hover {
  color: #97682b;
}

.title:hover::after {
  width: 100%;
  left: 0;
}

/* Bouton "Contacter Nous" */
.action-link {
  font-size: 16px;
  color: #ad7e3f; /* Couleur dorée pour correspondre au thème */
  font-family: "Noto Kufi Arabic", sans-serif;
  font-weight: bold;
  margin-right: 35%;
  margin-top: -5px;
  text-transform: uppercase; /* Texte en majuscules */
  letter-spacing: 1px; /* Espacement des lettres */
  transition: all 0.3s ease; /* Transition fluide */
  padding: 4px 16px; /* Padding pour un meilleur rendu */
  border-radius: 4px; /* Bords arrondis */
  background-color: transparent; /* Fond transparent */
}

.action-link:hover {
  color: #ffffff; /* Texte blanc au survol */
  background-color: #ad7e3f; /* Fond doré au survol */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Ombre légère */
  transform: translateY(-2px); /* Effet de légère élévation */
}
</style>
